import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface VatSettings {
  rate: number;
  enabled: boolean;
}

export function useVatRate() {
  const [vatRate, setVatRate] = useState<number>(7.5); // Default 7.5%
  const [vatEnabled, setVatEnabled] = useState<boolean>(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVatRate = async () => {
      try {
        const { data, error } = await supabase
          .from('platform_settings')
          .select('value')
          .eq('key', 'vat_rate')
          .maybeSingle();

        if (error) {
          console.warn('Error fetching VAT rate, using default:', error);
          return;
        }

        if (data?.value) {
          const settings = data.value as unknown as VatSettings;
          setVatRate(settings.rate || 7.5);
          setVatEnabled(settings.enabled !== false);
        }
      } catch (error) {
        console.error('Failed to fetch VAT rate:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVatRate();
  }, []);

  const calculateVat = (amount: number): number => {
    if (!vatEnabled) return 0;
    return amount * (vatRate / 100);
  };

  return {
    vatRate,
    vatEnabled,
    loading,
    calculateVat
  };
}
